export const WIDGET_PROPERTY_PREFIX = 'custom:';
